import { webAuthToken } from './webAuth';

const PROJECT_API = 'https://icandesignapp.com/projects';

/** The catalog's project-file request; the signed-in user's token lets the catalog keep the estimates it strips for others. */
export function projectFileRequest(id: string): { url: string; init: RequestInit } {
  const token = webAuthToken();
  return { url: `${PROJECT_API}/${id}/project`, init: token ? { headers: { Authorization: `Bearer ${token}` } } : {} };
}
